import api from './api';
import type { CatS2210PayloadContract } from '@sstexames/shared-types';

export interface Envio {
  id: string;
  mes_referencia: string;
  status: string;
  data_envio?: string;
  data_processamento?: string;
  total_itens: number;
  itens_processados: number;
  itens_com_erro: number;
  protocolo_envio?: string;
  relatorios: Array<{
    id: string;
    arquivo_nome: string;
    mes_referencia: string;
    created_at: string;
  }>;
}

export interface ColaboradorParaCat {
  id: number;
  nome: string;
  cpf: string;
  matricula_esocial?: string | null;
  cargo_nome?: string | null;
  setor_nome?: string | null;
}

export interface CatListItem {
  id: string;
  colaborador?: {
    id: number;
    nome: string;
    cpf: string;
  } | null;
  tipo_evento: string;
  tipo_acidente: string;
  data_acidente: string;
  hora_acidente?: string;
  cid_10?: string;
  estado_atual: string;
  status: string;
  protocolo_envio?: string | null;
  recibo_processamento?: string | null;
  mensagem_erro?: string | null;
  created_at: string;
}

class ESocialService {
  async listEnvios(mes?: string, status?: string): Promise<Envio[]> {
    const params: Record<string, string> = {};
    if (mes) params.mes = mes;
    if (status) params.status = status;

    const response = await api.get<Envio[]>('/esocial/envios', { params });
    return response.data;
  }

  async getEnvio(id: string): Promise<Envio> {
    const response = await api.get<Envio>(`/esocial/envios/${id}`);
    return response.data;
  }

  async downloadRelatorio(relatorioId: string): Promise<void> {
    const response = await api.get(`/esocial/relatorios/${relatorioId}/download`, {
      responseType: 'blob',
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `relatorio-${relatorioId}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  async listColaboradoresParaCat(): Promise<ColaboradorParaCat[]> {
    const response = await api.get<ColaboradorParaCat[]>('/esocial/colaboradores');
    return response.data;
  }

  async criarCatS2210(payload: CatS2210PayloadContract): Promise<{ id: string; status: string; estado_atual: string }> {
    const response = await api.post<{ id: string; status: string; estado_atual: string }>(
      '/esocial/cat-s2210',
      payload,
    );
    return response.data;
  }

  async listCats(): Promise<CatListItem[]> {
    const response = await api.get<CatListItem[]>('/esocial/cat-s2210');
    return response.data;
  }
}

export const esocialService = new ESocialService();
export default esocialService;
